{
  "_note": "Cosmetic presentation only. This does not add collision tiles, shops or gameplay zones.",
  "weaponFx": {
    "particles": 128, "casings": 72, "decals": 32, "shots": 64, "trails": 256,
    "flashSec": 0.05, "eventGraceSec": 0.25, "sparkSec": 0.18, "casingSec": 2.4, "decalSec": 0.22,
    "highDamage": 30, "shotgunEjectSec": 0.18,
    "comfort": [1, 0.72, 0.45]
  },
  "hackFx": {
    "links": 16, "bursts": 24, "refusals": 8, "lights": 6, "labels": 12,
    "ackSec": 0.1, "linkSec": 0.2, "burstSec": 0.45, "refuseSec": 1, "refuseGapSec": 0.4, "eventGraceSec": 0.25, "lightSec": 0.18,
    "scanRange": 260
  },
  "shinganFx": {
    "_note": "M10 Shingan's cosmetic effects (client/src/shingan-fx.ts): caps on live effects and their lengths in seconds. The wind-up telegraph is always shown; extra flourish only with ?bossfx=1.",
    "rings": 6, "ghosts": 4, "pops": 6, "bits": 48,
    "sweepSec": 0.3, "ringSec": 0.5, "ghostSec": 0.5, "popSec": 0.6, "arriveSec": 1.2, "shimmerGapSec": 2.2
  },
  "countryFx": {
    "_note": "M10 Kanemori Sanctuary countryside wildlife and petals (client/src/country-fx.ts): client-only, no collision, no server state. Critters live in tile rects inside the countryside (x258-333, y46-141), start at fixed seeded spots and shy away from players. petals and steam cap the live sakura petals and onsen wisps; radius (world px) is how near the camera an area must be to animate. All counts are validated and bounded (invariant 7); everything is scaled down by the comfort grade.",
    "petals": 40, "petalSec": 5, "steam": 24, "maxCritters": 48, "radius": 560,
    "critters": [
      { "kind": "deer", "x": 276, "y": 47, "w": 8, "h": 14, "count": 3 },
      { "kind": "deer", "x": 260, "y": 131, "w": 12, "h": 9, "count": 2 },
      { "kind": "tanuki", "x": 258, "y": 96, "w": 5, "h": 14, "count": 1 },
      { "kind": "tanuki", "x": 302, "y": 124, "w": 11, "h": 8, "count": 1 },
      { "kind": "crow", "x": 283, "y": 134, "w": 10, "h": 3, "count": 3 },
      { "kind": "crow", "x": 262, "y": 92, "w": 8, "h": 4, "count": 2 },
      { "kind": "heron", "x": 290, "y": 84, "w": 14, "h": 12, "count": 2 },
      { "kind": "heron", "x": 277, "y": 114, "w": 2, "h": 3, "count": 1 },
      { "kind": "koi", "x": 279, "y": 115, "w": 9, "h": 5, "count": 6 },
      { "kind": "butterfly", "x": 275, "y": 111, "w": 17, "h": 15, "count": 4 },
      { "kind": "butterfly", "x": 276, "y": 47, "w": 8, "h": 14, "count": 2 },
      { "kind": "firefly", "x": 282, "y": 84, "w": 22, "h": 30, "count": 16 }
    ]
  },
  "surface": {
    "road": "#0d1422",
    "roadSpeckle": "#172334",
    "sidewalk": "#354153",
    "sidewalkSeam": "#273244",
    "curb": "#778392",
    "alley": "#222c3b",
    "plaza": "#30384a"
  },
  "roofs": [
    {
      "base": "#465269",
      "light": "#718096",
      "shade": "#303b50",
      "wall": "#202b3e"
    },
    {
      "base": "#3e5360",
      "light": "#6a8390",
      "shade": "#2b3d4b",
      "wall": "#1c2c38"
    },
    {
      "base": "#56535b",
      "light": "#85818a",
      "shade": "#3b3947",
      "wall": "#292536"
    }
  ],
  "windows": {
    "warm": "#c7a465",
    "dim": "#786b51",
    "cool": "#548f9a",
    "dark": "#111a29"
  },
  "lights": {
    "pink": "#ff4fbc",
    "teal": "#45e4f4",
    "yellow": "#ffc56b"
  },
  "neon": {
    "x": 82,
    "y": 10,
    "w": 32,
    "h": 46,
    "signs": [
      {
        "x": 87,
        "y": 27,
        "text": "ARCADE",
        "color": "pink",
        "vertical": false
      },
      {
        "x": 111,
        "y": 27,
        "text": "BAR",
        "color": "pink",
        "vertical": false
      },
      {
        "x": 95,
        "y": 17,
        "text": "CLUB",
        "color": "teal",
        "vertical": false
      },
      {
        "x": 103,
        "y": 53,
        "text": "KABUKI",
        "color": "pink",
        "vertical": false
      },
      {
        "x": 113,
        "y": 40,
        "text": "24H",
        "color": "teal",
        "vertical": true
      }
    ]
  },
  "_blocks": "Authored blocks (client/src/blocks.ts). Lots split the block's solid tiles into buildings; facade = south-wall rows; step = tile rows of the tall rear section; props are [kind, x, y(, x2, y2)] in lot-local pixels.",
  "blocks": [
    {
      "id": "karaoke",
      "x": 82, "y": 36, "w": 32, "h": 18,
      "facade": 3,
      "lots": [
        { "x": 82, "w": 7, "front": "arcade", "roof": "tar", "step": 7, "lowRoof": "slate",
          "props": [["hut", 12, 14], ["ac", 60, 12], ["ac", 80, 12], ["duct", 40, 32, 72, 62], ["dish", 18, 66],
                    ["tank", 66, 128], ["ac", 14, 140], ["ac", 14, 158], ["skylight", 34, 196], ["vent", 84, 206]] },
        { "x": 89, "w": 7, "front": "karaoke", "roof": "slate", "step": 9, "lowRoof": "ribbed",
          "props": [["ac", 12, 14], ["ac", 32, 14], ["ac", 52, 14], ["duct", 20, 34, 80, 88], ["skylight", 62, 44], ["hut", 12, 92],
                    ["vent", 14, 172], ["dish", 44, 182], ["ac", 66, 176]] },
        { "x": 98, "w": 7, "front": "kabuki", "roof": "ribbed", "step": 6, "lowRoof": "tar",
          "props": [["tank", 12, 14], ["ac", 52, 14], ["ac", 74, 14], ["vent", 54, 40],
                    ["hut", 70, 118], ["duct", 18, 132, 44, 196], ["ac", 52, 190], ["vent", 20, 150]] },
        { "x": 105, "w": 9, "front": "izakaya", "roof": "slate", "step": 10, "lowRoof": "tile",
          "props": [["tank", 104, 18], ["ac", 18, 18], ["ac", 38, 18], ["duct", 30, 36, 60, 100], ["hut", 58, 100], ["vent", 110, 200]] }
      ]
    },
    {
      "id": "hotel-corner",
      "_note": "Environment-art test scene: NE corner of the crossroads at x76-79 y30-33 (west of Ghost Lot).",
      "x": 82, "y": 20, "w": 18, "h": 8,
      "facade": 3,
      "lots": [
        { "x": 82, "w": 9, "front": "ramenHouse", "roof": "tar", "step": 2, "lowRoof": "slate",
          "props": [["ac", 30, 4], ["ac", 50, 4], ["vent", 112, 7], ["dish", 88, 5],
                    ["hood", 22, 40], ["duct", 40, 44, 92, 62], ["tank", 108, 37], ["vent", 64, 62]] },
        { "x": 91, "w": 9, "front": "karaokeHall", "roof": "ribbed", "step": 2, "lowRoof": "tar",
          "props": [["ac", 10, 4], ["ac", 30, 4], ["ac", 50, 4], ["dish", 110, 5],
                    ["skylight", 14, 42], ["ac", 52, 40], ["duct", 60, 58, 90, 58], ["hut", 104, 38]] }
      ]
    },
    { "id": "okubo-delivery", "_note": "Okubo test scene: back-of-house on the delivery lane.", "x": 130, "y": 12, "w": 28, "h": 7, "facade": 3,
      "lots": [
        { "x": 130, "w": 9, "front": "depot", "roof": "metal", "props": [["ac", 10, 8], ["ac", 34, 8], ["vent", 100, 40], ["tank", 110, 6]] },
        { "x": 139, "w": 10, "front": "walkup", "roof": "tar", "props": [["laundry", 16, 10], ["laundry", 60, 10], ["ac", 110, 8], ["vent", 130, 40]] },
        { "x": 149, "w": 9, "front": "depot", "roof": "metal", "props": [["tarp", 14, 8], ["ac", 70, 10], ["ac", 100, 34]] } ] },
    { "id": "okubo-market-west", "_note": "Okubo test scene: market street (Okubo-dori) south faces.", "x": 130, "y": 21, "w": 28, "h": 7, "facade": 3,
      "lots": [
        { "x": 130, "w": 7, "front": "walkup", "roof": "tar", "props": [["laundry", 10, 8], ["ac", 70, 8], ["vent", 80, 40]] },
        { "x": 137, "w": 7, "front": "grocer", "roof": "slate", "props": [["ac", 10, 8], ["ac", 34, 8], ["tank", 80, 6]] },
        { "x": 144, "w": 6, "front": "cafe", "roof": "metal", "props": [["vent", 12, 10], ["tarp", 50, 30]] },
        { "x": 150, "w": 8, "front": "walkup", "roof": "tar", "props": [["laundry", 14, 10], ["laundry", 60, 36], ["ac", 96, 8]] } ] },
    { "id": "okubo-market-hall", "_note": "Okubo test scene: landmark market hall and a grocer.", "x": 166, "y": 12, "w": 15, "h": 16, "facade": 3,
      "lots": [
        { "x": 166, "w": 8, "front": "marketHall", "roof": "ribbed", "step": 6, "lowRoof": "metal",
          "props": [["skylight", 20, 20], ["skylight", 70, 20], ["ac", 14, 120], ["ac", 40, 120], ["tank", 90, 130]] },
        { "x": 174, "w": 7, "front": "grocer", "roof": "tar", "step": 7, "lowRoof": "tile",
          "props": [["ac", 10, 10], ["ac", 34, 10], ["hood", 66, 14], ["laundry", 20, 140], ["tank", 70, 150]] } ] },
    { "id": "okubo-market-east", "_note": "Okubo test scene: cafe, cosmetics and Korean BBQ on Okubo-dori.", "x": 183, "y": 12, "w": 15, "h": 16, "facade": 3,
      "lots": [
        { "x": 183, "w": 5, "front": "cafe", "roof": "slate", "step": 7, "lowRoof": "tar", "props": [["ac", 8, 10], ["ac", 40, 40], ["tarp", 40, 136]] },
        { "x": 188, "w": 5, "front": "beauty", "roof": "ribbed", "step": 6, "lowRoof": "slate", "props": [["ac", 10, 10], ["ac", 40, 10], ["laundry", 30, 150]] },
        { "x": 193, "w": 5, "front": "bbq", "roof": "tar", "step": 8, "lowRoof": "metal", "props": [["hood", 10, 12], ["hood", 44, 20], ["vent", 50, 160], ["hood", 14, 150]] } ] },
    { "id": "gai-north", "_note": "Golden Gai pocket (Okubo test scene): low single-storey bars on Ichiban-gai.", "x": 166, "y": 36, "w": 32, "h": 4, "facade": 2,
      "lots": [
        { "x": 166, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["vent", 4, 6]] },
        { "x": 169, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["ac", 20, 4]] },
        { "x": 172, "w": 4, "front": "goldenBar", "roof": "ribbed", "props": [["tarp", 30, 6]] },
        { "x": 176, "w": 3, "front": "goldenBar", "roof": "metal", "props": [] },
        { "x": 179, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["vent", 28, 4]] },
        { "x": 182, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["ac", 6, 4]] },
        { "x": 185, "w": 4, "front": "goldenBar", "roof": "tile", "props": [["hood", 30, 8]] },
        { "x": 189, "w": 3, "front": "goldenBar", "roof": "metal", "props": [] },
        { "x": 192, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["vent", 10, 6]] },
        { "x": 195, "w": 3, "front": "goldenBar", "roof": "ribbed", "props": [["ac", 24, 4]] } ] },
    { "id": "gai-mid-west", "x": 166, "y": 42, "w": 15, "h": 4, "facade": 2,
      "lots": [
        { "x": 166, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["ac", 4, 4]] },
        { "x": 169, "w": 3, "front": "goldenBar", "roof": "metal", "props": [] },
        { "x": 172, "w": 3, "front": "goldenBar", "roof": "tile", "props": [["vent", 30, 6]] },
        { "x": 175, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["tarp", 8, 6]] },
        { "x": 178, "w": 3, "front": "goldenBar", "roof": "tar", "props": [] } ] },
    { "id": "gai-mid-east", "x": 182, "y": 42, "w": 16, "h": 4, "facade": 2,
      "lots": [
        { "x": 182, "w": 4, "front": "goldenBar", "roof": "ribbed", "props": [["ac", 40, 4]] },
        { "x": 186, "w": 3, "front": "goldenBar", "roof": "metal", "props": [] },
        { "x": 189, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["hood", 10, 8]] },
        { "x": 192, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["vent", 30, 6]] },
        { "x": 195, "w": 3, "front": "goldenBar", "roof": "tile", "props": [] } ] },
    { "id": "gai-south-west", "x": 166, "y": 48, "w": 9, "h": 6, "facade": 3,
      "lots": [
        { "x": 166, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["ac", 6, 8]] },
        { "x": 169, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["tarp", 10, 20]] },
        { "x": 172, "w": 3, "front": "goldenBar", "roof": "ribbed", "props": [["vent", 20, 10]] } ] },
    { "id": "gai-south-east", "x": 176, "y": 48, "w": 22, "h": 6, "facade": 3,
      "lots": [
        { "x": 176, "w": 6, "front": "walkup", "roof": "tar", "props": [["laundry", 10, 8], ["ac", 60, 20]] },
        { "x": 182, "w": 3, "front": "goldenBar", "roof": "metal", "props": [["vent", 10, 8]] },
        { "x": 185, "w": 3, "front": "goldenBar", "roof": "tile", "props": [] },
        { "x": 188, "w": 4, "front": "goldenBar", "roof": "metal", "props": [["ac", 30, 10], ["tarp", 4, 24]] },
        { "x": 192, "w": 3, "front": "goldenBar", "roof": "tar", "props": [["hood", 14, 10]] },
        { "x": 195, "w": 3, "front": "goldenBar", "roof": "ribbed", "props": [] } ] },
    { "id": "hanabi-shrine", "_note": "Okubo landmark: the shrine at the head of its grounds, beside the Golden Gai pocket.", "x": 141, "y": 36, "w": 12, "h": 10, "facade": 3,
      "lots": [ { "x": 141, "w": 12, "front": "shrine", "roof": "tile", "props": [] } ] },
    { "id": "kemuri-yokocho", "_note": "Nishi test scene: Omoide-Yokocho-style stalls along the tracks.", "x": 13, "y": 101, "w": 24, "h": 4, "facade": 3,
      "lots": [
        { "x": 13, "w": 3, "front": "yakitori", "roof": "metal", "props": [] },
        { "x": 16, "w": 4, "front": "yakitori", "roof": "tar", "props": [["vent", 10, 2]] },
        { "x": 20, "w": 3, "front": "yakitori", "roof": "metal", "props": [] },
        { "x": 23, "w": 4, "front": "yakitori", "roof": "ribbed", "props": [["vent", 40, 2]] },
        { "x": 27, "w": 3, "front": "yakitori", "roof": "tar", "props": [] },
        { "x": 30, "w": 3, "front": "yakitori", "roof": "metal", "props": [["vent", 6, 2]] },
        { "x": 33, "w": 4, "front": "yakitori", "roof": "tar", "props": [] } ] },
    { "id": "station-west", "_note": "Nishi landmark: Shinjuku Terminal, west half.", "x": 47, "y": 101, "w": 9, "h": 7, "facade": 3,
      "lots": [ { "x": 47, "w": 9, "front": "stationWest", "roof": "vault", "props": [] } ] },
    { "id": "station-east", "_note": "Nishi landmark: Shinjuku Terminal, east half.", "x": 64, "y": 101, "w": 9, "h": 7, "facade": 3,
      "lots": [ { "x": 64, "w": 9, "front": "stationEast", "roof": "vault", "props": [] } ] },
    { "id": "station-retail", "_note": "Nishi test scene: department store and station shops facing the avenue.", "x": 83, "y": 101, "w": 30, "h": 7, "facade": 3,
      "lots": [
        { "x": 83, "w": 16, "front": "deptStore", "roof": "slate", "props": [["cooler", 20, 10], ["cooler", 60, 10], ["cage", 120, 8], ["hut", 200, 10]] },
        { "x": 99, "w": 14, "front": "stationRetail", "roof": "ribbed", "props": [["ac", 14, 10], ["ac", 40, 10], ["skylight", 100, 12], ["vent", 180, 36]] } ] },
    { "id": "nishi-office", "_note": "Nishi test scene: office slab and loading dock.", "x": 13, "y": 118, "w": 24, "h": 13, "facade": 3,
      "lots": [
        { "x": 13, "w": 14, "front": "officeSlab", "roof": "glass", "step": 5, "lowRoof": "slate",
          "props": [["mast", 20, 10], ["cooler", 60, 8], ["cooler", 100, 8], ["cage", 150, 6], ["ac", 20, 100], ["skylight", 80, 104], ["ac", 160, 100]] },
        { "x": 27, "w": 10, "front": "loadingDock", "roof": "slate", "props": [["cage", 20, 20], ["ac", 90, 20], ["hut", 60, 96], ["vent", 120, 110]] } ] },
    { "id": "west-exit-south", "_note": "Nishi test scene: car park and substation behind the West Exit plaza.", "x": 47, "y": 125, "w": 26, "h": 6, "facade": 3,
      "lots": [
        { "x": 47, "w": 14, "front": "parking", "roof": "deck", "props": [] },
        { "x": 61, "w": 12, "front": "utility", "roof": "slate", "props": [["cage", 10, 6], ["cooler", 70, 8], ["cooler", 110, 8], ["vent", 160, 12]] } ] },
    { "id": "twin-tower-west", "_note": "Nishi landmark: Kanemori twin towers.", "x": 83, "y": 118, "w": 12, "h": 13, "facade": 3,
      "lots": [ { "x": 83, "w": 12, "front": "twinTower", "roof": "glass", "step": 4, "lowRoof": "glass",
                  "props": [["heli", 70, 2], ["mast", 160, 10], ["cooler", 20, 90], ["cooler", 60, 90], ["cage", 110, 92]] } ] },
    { "id": "twin-tower-east", "x": 101, "y": 118, "w": 12, "h": 13, "facade": 3,
      "lots": [ { "x": 101, "w": 12, "front": "twinTower", "roof": "glass", "step": 4, "lowRoof": "glass",
                  "props": [["mast", 14, 10], ["heli", 90, 2], ["cage", 20, 92], ["cooler", 120, 90], ["cooler", 156, 90]] } ] }
  ],
  "_paving": "Paving zones: sidewalk/plaza material and curb lamp style (client/src/fronts-tokyo.ts) over the whole of Okubo and Nishi-Shinjuku; the first matching zone wins.",
  "paving": [
    { "style": "gravel", "x": 141, "y": 46, "w": 12, "h": 8 },
    { "style": "okubo", "x": 128, "y": 0, "w": 128, "h": 96 },
    { "style": "nishi", "x": 0, "y": 96, "w": 256, "h": 48 },
    { "style": "nishi", "x": 56, "y": 90, "w": 8, "h": 6 }
  ],
  "lowArt": [
    { "kind": "toro", "x": 144, "y": 50, "w": 1, "h": 2 }, { "kind": "toro", "x": 149, "y": 50, "w": 1, "h": 2 },
    { "kind": "planter", "x": 50, "y": 120, "w": 2, "h": 1 }, { "kind": "planter", "x": 69, "y": 120, "w": 2, "h": 1 },
    { "kind": "metro", "x": 64, "y": 121, "w": 3, "h": 2 }
  ],
  "_platforms": "Island platforms (tile rects on a rail corridor). Station concourses are the world.json plazas that cross a rail line.",
  "platforms": [ { "x": 13, "y": 96, "w": 100, "h": 5 } ],
  "_ambience": "City sound per district (client/src/audio.ts): pad pitch Hz and lowpass tone Hz, plus a filtered noise bed (biquad type, Hz, gain).",
  "ambience": {
    "kabuki": { "pad": 55, "tone": 180, "bedType": "bandpass", "bedHz": 900, "bed": 0 },
    "okubo": { "pad": 65.4, "tone": 230, "bedType": "bandpass", "bedHz": 1700, "bed": 0.014 },
    "nishi": { "pad": 49, "tone": 140, "bedType": "lowpass", "bedHz": 240, "bed": 0.022 },
    "sanctuary": { "pad": 41.2, "tone": 110, "bedType": "lowpass", "bedHz": 180, "bed": 0.01 }
  },
  "_alleyLanterns": "Lantern strings hang over every foot alley; this overrides that by alley name (validated against world.json).",
  "alleyLanterns": { "Pachinko row": true, "Nishi skywalk passage": false },
  "_districts": "Every other building rectangle is planned automatically (client/src/city-plan.ts). The first district rect containing a block's centre picks its style; otherwise defaultStyle. Signs from world.json / neon.signs become facade hints through signFronts.",
  "defaultStyle": "concrete",
  "districts": [
    { "style": "corp", "x": 44, "y": 0, "w": 34, "h": 30 },
    { "style": "oni", "x": 78, "y": 56, "w": 50, "h": 40 },
    { "style": "neon", "x": 76, "y": 0, "w": 52, "h": 56 },
    { "style": "lantern", "x": 0, "y": 0, "w": 40, "h": 96 },
    { "style": "gai", "x": 164, "y": 36, "w": 36, "h": 18 },
    { "style": "gai", "x": 204, "y": 36, "w": 40, "h": 18 },
    { "style": "okubo", "x": 128, "y": 0, "w": 128, "h": 96 },
    { "style": "station", "x": 0, "y": 96, "w": 256, "h": 14 },
    { "style": "nishi", "x": 0, "y": 110, "w": 256, "h": 34 },
    { "style": "temple", "x": 256, "y": 0, "w": 80, "h": 144 }
  ],
  "_lots": "lotMin/lotMax: generated lot widths in tiles (default 5-9). Golden Gai packs narrow bars, Nishi-Shinjuku wide office slabs.",
  "styles": {
    "concrete": { "fronts": ["office", "apartment", "shutter", "office", "apartment", "konbini"], "roofs": ["slate", "tar", "ribbed"], "lowRoof": "slate",
                  "props": ["ac", "ac", "vent", "hut", "tank", "skylight", "dish"], "density": 0.42 },
    "corp":     { "fronts": ["office", "apartment", "office", "office", "konbini"], "roofs": ["slate", "ribbed"], "lowRoof": "slate",
                  "props": ["ac", "ac", "ac", "skylight", "hut", "dish"], "density": 0.5 },
    "lantern":  { "fronts": ["izakaya", "ramenHouse", "shop", "apartment", "shop"], "roofs": ["slate", "tar"], "lowRoof": "tile",
                  "props": ["ac", "vent", "tank", "ac", "hood"], "density": 0.3 },
    "neon":     { "fronts": ["arcade", "karaokeHall", "hotel", "bar", "pachinko"], "roofs": ["tar", "ribbed", "slate"], "lowRoof": "tar",
                  "props": ["ac", "ac", "dish", "vent", "hut", "tank", "hood"], "density": 0.45 },
    "oni":      { "fronts": ["bar", "pachinko", "shutter", "hotel", "bar", "apartment"], "roofs": ["tar", "ribbed"], "lowRoof": "tar",
                  "props": ["ac", "vent", "tank", "hut"], "density": 0.35 },
    "okubo":    { "fronts": ["grocer", "walkup", "bbq", "cafe", "walkup", "beauty", "grocer", "depot", "konbini"], "roofs": ["tar", "metal", "slate", "ribbed"], "lowRoof": "tile",
                  "props": ["ac", "ac", "vent", "tank", "hood", "laundry", "tarp"], "density": 0.42, "lotMin": 4, "lotMax": 7 },
    "gai":      { "fronts": ["goldenBar", "goldenBar", "goldenBar", "yakitori"], "roofs": ["metal", "tar", "tile", "ribbed"], "lowRoof": "metal",
                  "props": ["ac", "vent", "hood", "tarp"], "density": 0.3, "lotMin": 3, "lotMax": 4 },
    "station":  { "fronts": ["stationRetail", "deptStore", "konbini", "stationRetail", "loadingDock"], "roofs": ["slate", "ribbed", "metal"], "lowRoof": "slate",
                  "props": ["ac", "ac", "vent", "skylight", "cooler", "cage"], "density": 0.45, "lotMin": 7, "lotMax": 11 },
    "nishi":    { "fronts": ["officeSlab", "officeSlab", "loadingDock", "officeSlab", "parking", "utility"], "roofs": ["glass", "slate", "glass"], "lowRoof": "slate",
                  "props": ["ac", "cooler", "skylight", "cage", "mast", "cooler"], "density": 0.5, "lotMin": 10, "lotMax": 16 },
    "temple":   { "fronts": ["shrine"], "roofs": ["tile"], "lowRoof": "tile",
                  "props": ["vent"], "density": 0.05, "lotMin": 8, "lotMax": 16, "_note": "M10 placeholder for the Kanemori Sanctuary strip; Phase 3 replaces it with real temple art" }
  },
  "signFronts": { "KABUKI": "kabuki", "PACHI": "pachinko", "HOTEL": "hotel", "SLEEP": "hotel", "RAMEN": "ramenHouse", "ONI": "bar",
                  "KARAOKE": "karaokeHall", "BAR": "bar", "CLUB": "bar", "KANEMORI": "office", "ARCADE": "arcade", "24H": "konbini" },
  "roofDetail": 0.6,
  "lighting": {
    "_note": "Dynamic lighting (client/src/lighting.ts): a light map of additive sprites at neon sources, composited over the world (not the HUD) by a filter: lit = scene*(ambient + light*gain) + light*wash*(0.35+scene luma), then a bloom (bright-pass above bloom.threshold, blurred at bloom.scale of the view, added at bloom.strength). Each kind: radius (px of world), intensity (0-1.5 into the light map). ?light=0 or Settings > Neon lighting turns it off; Low effects drops the bloom.",
    "defaultOn": true,
    "comfort": {
      "_note": "Settings > Neon intensity (Full / Soft / Low). Scenery steps back, gameplay (actors, vehicles, pickups, markers, projectiles, flashes, headlights, sirens) stays full. sat/val: colour matrix on the ground layer only (1 = unchanged); lights: scale on sign and lamp lights; bloom, wash: scale on the filter's bloom strength and wash; glow: alpha of the neon glow layer; reflect: alpha of puddles and wet decals.",
      "levels": [
        { "name": "Full", "sat": 0.86, "val": 0.94, "lights": 0.82, "bloom": 0.75, "wash": 0.8, "glow": 0.8, "reflect": 0.75 },
        { "name": "Soft", "sat": 0.72, "val": 0.9, "lights": 0.65, "bloom": 0.5, "wash": 0.6, "glow": 0.6, "reflect": 0.55 },
        { "name": "Low", "sat": 0.55, "val": 0.86, "lights": 0.45, "bloom": 0.2, "wash": 0.35, "glow": 0.35, "reflect": 0.35 }
      ]
    },
    "ambient": "#8888b4",
    "_zones": "Places with their own night: the ambient eases toward the zone's colour as the camera centre goes in (fade = tiles of easing inside the edge). The Kanemori monastery (M10) is darker and colder under its mist; the mist itself is baked into the 2x ground (hd-sanctuary-place.ts), so it still reads with lighting off.",
    "zones": [
      { "id": "monastery", "x": 276, "y": 0, "w": 60, "h": 46, "fade": 8, "ambient": "#6c76a0" }
    ],
    "gain": 2.6,
    "wash": 0.1,
    "bloom": { "strength": 0.3, "threshold": 0.88, "scale": 0.25, "blur": 6 },
    "actor": { "radius": 30, "intensity": 0, "color": "#c8d0ff" },
    "mapScale": 0.75,
    "maxLights": 260,
    "sign":     { "radiusMul": 2.1, "intensity": 0.6 },
    "lamp":     { "radiusMul": 1.5, "intensity": 0.8, "flickerEvery": 6 },
    "signal":   { "radius": 16, "intensity": 0.9, "bloom": 0.35 },
    "headlight": { "length": 96, "width": 64, "intensity": 0.95 },
    "taillight": { "radius": 14, "intensity": 0.7, "bloom": 0.25 },
    "siren":    { "radius": 74, "intensity": 1.1, "bloom": 0.45 },
    "hazard":   { "radius": 56, "intensity": 1.2, "bloom": 0.5 },
    "flash": {
      "shot":  { "color": "#ffe9a0", "radius": 34, "intensity": 1.2, "sec": 0.09, "bloom": 0.5 },
      "boom":  { "color": "#ff9a40", "radius": 120, "intensity": 1.4, "sec": 0.55, "bloom": 0.5 },
      "crash": { "color": "#fff2d0", "radius": 34, "intensity": 0.9, "sec": 0.15, "bloom": 0.3 },
      "spark": { "color": "#ffe080", "radius": 22, "intensity": 0.9, "sec": 0.1, "bloom": 0.4 },
      "hack":  { "color": "#d8ff3a", "radius": 56, "intensity": 1.1, "sec": 0.45, "bloom": 0.45 },
      "emp":   { "color": "#2de2c8", "radius": 96, "intensity": 1.3, "sec": 0.5, "bloom": 0.5 }
    }
  },
  "effects": {
    "scanlines": 0.08,
    "fog": 0.28,
    "reflection": 0.18,
    "blockGlow": 0.6,
    "maxLights": 2000,
    "reflectionReach": 88
  }
}
